export const WIDGET_NAME = 'membership_recapture_customers';
export const OFFER_TYPES = {
    REACTIVATE: 'REACTIVATE',
    NO_REACTIVATE: 'NO_REACTIVATE',
};

export const OFFER_ZERO = 0;
export const SIGN_PLUS = '+';

export const TRACKING = {
    CATEGORY: 'flights_ancillaries_page',
    ACTION: 'prime_renewal',
    LABEL: {
        INIT: 'prime-renewal',
        EVENT: {
            CLICK: 'click',
            CONTINUE: 'continue',
        },
        PAGE: {
            ONLOAD: 'onload_pag',
            ERROR: 'error_pag',
            REACTIVATE: 'reactivate_pag',
            NOREACTIVATE: 'no-reactivate_pag',
        },
        ANCILLARIES: 'anc',
        PAY: 'pay',
    },
};

export const TRACKING_LABEL = {
    ON_CHANGE_OFFER_REACTIVATE:
        `${TRACKING.LABEL.INIT}_${TRACKING.LABEL.EVENT.CLICK}:` + `${TRACKING.LABEL.PAGE.REACTIVATE}:${TRACKING.LABEL.ANCILLARIES}`,
    ON_CHANGE_OFFER_NOREACTIVATE:
        `${TRACKING.LABEL.INIT}_${TRACKING.LABEL.EVENT.CLICK}:` + `${TRACKING.LABEL.PAGE.NOREACTIVATE}:${TRACKING.LABEL.ANCILLARIES}`,
    ON_LOAD: `${TRACKING.LABEL.INIT}_${TRACKING.LABEL.PAGE.ONLOAD}:${TRACKING.LABEL.ANCILLARIES}`,
    ON_ERROR: `${TRACKING.LABEL.INIT}_${TRACKING.LABEL.EVENT.CONTINUE}:${TRACKING.LABEL.PAGE.ERROR}:${TRACKING.LABEL.ANCILLARIES}`,
    ON_CONTINUE_REACTIVATE: `${TRACKING.LABEL.INIT}_${TRACKING.LABEL.EVENT.CONTINUE}:${TRACKING.LABEL.PAGE.REACTIVATE}:${TRACKING.LABEL.ANCILLARIES}`,
    ON_CONTINUE_NOREACTIVATE:
        `${TRACKING.LABEL.INIT}_${TRACKING.LABEL.EVENT.CONTINUE}:` + `${TRACKING.LABEL.PAGE.NOREACTIVATE}:${TRACKING.LABEL.ANCILLARIES}`,
    ON_PAYMENT_REACTIVATE: `${TRACKING.LABEL.INIT}_${TRACKING.LABEL.EVENT.CONTINUE}:${TRACKING.LABEL.PAGE.REACTIVATE}:${TRACKING.LABEL.PAY}`,
    ON_PAYMENT_NOREACTIVATE: `${TRACKING.LABEL.INIT}_${TRACKING.LABEL.EVENT.CONTINUE}:${TRACKING.LABEL.PAGE.NOREACTIVATE}:${TRACKING.LABEL.PAY}`,
};

export const OFFER_BENEFITS_KEYS_INIT_SUBSTR = {
    REACTIVATE: 'offerActivateMembershipBenefit',
    NO_REACTIVATE: 'offerNoActivateMembershipBenefit',
};

export const CLASSNAMES = {
    ODF_HIDDEN: 'odf-hidden',
    DISABLED: 'disabled',
    ANIMATION: 'od-membership-recapture-customers-no-reactivate-message-animation',
};

export const SELECTORS = {
    OFFER_INPUT_SELECTABLE_CONTENT: '.odf-selectable-content',
    OFFER_INPUT: '[data-id=od-membership-recapture-customers-offer-container-header-radio-container-input]',
    OFFER_REACTIVATE_INPUT: `[data-id=od-membership-recapture-customers-offer-container-header-radio-container-input][data-offer=REACTIVATE]`,
    OFFER_NO_REACTIVATE_INPUT: '[data-id=od-membership-recapture-customers-offer-container-header-radio-container-input][data-offer=NO_REACTIVATE]',
    ERROR_PENDING_REACTIVATE_DECISION_MESSAGE_CONTAINER: '[data-id=membership-recapture-customers_error-pending-decision]',
    CONFIRMATION_MESSAGE_REACTIVATE: '[data-id=od-membership-recapture-customers-confirmation-msg][data-isReactivateOfferSelected=true]',
    CONFIRMATION_MESSAGE_NO_REACTIVATE: '[data-id=od-membership-recapture-customers-confirmation-msg][data-isreactivateofferselected=false]',
};

export const EVENTS = {
    [`click ${SELECTORS.OFFER_INPUT}`]: 'onChangeOffer',
};
